const NUMBER_OF_GUESTS_OPTIONS = [
  { value: "2 - 10", label: "2 - 10" },
  { value: "10 - 20", label: "10 - 20" },
  { value: "More than 20", label: "More than 20" },
];

export default NUMBER_OF_GUESTS_OPTIONS;